"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaxQualificationsCountForNachweisTyp = getMaxQualificationsCountForNachweisTyp;
exports.removeUnknownParagraphs = void 0;
var _nachweisTypConstants = require("./nachweisTypConstants");
var maxQualificationsPerGroupDaily = 5;
var maxQualificationsPerGroupWeekly = 9;
function getMaxQualificationsCountForNachweisTyp(nachweisTyp) {
  return nachweisTyp === _nachweisTypConstants.nachweisTypes.DAILY_WITH_QUALIFICATION ? maxQualificationsPerGroupDaily : maxQualificationsPerGroupWeekly;
}
var removeUnknownParagraphs = exports.removeUnknownParagraphs = function removeUnknownParagraphs(selectedParagraphs, qualifications) {
  if (!qualifications || !qualifications.length > 0) return selectedParagraphs;
  return selectedParagraphs.filter(function (p) {
    return qualifications.find(function (q) {
      return q.paragraph === p;
    });
  });
};